import './i18n';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { BuyerAuthProvider } from './context/BuyerAuthContext';
import { QuoteCartProvider } from './context/QuoteCartContext';
import PublicHeader from './components/PublicHeader';
import PublicFooter from './components/PublicFooter';
import QuoteDrawer from './components/QuoteDrawer';
import PageTracker from './components/PageTracker';
import HomePage from './pages/HomePage';
import CatalogPage from './pages/CatalogPage';
import ProductDetailPage from './pages/ProductDetailPage';
import AboutPage from './pages/AboutPage';
import PrivateLabelPage from './pages/PrivateLabelPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboard from './pages/AdminDashboard';
import BuyerLoginPage from './pages/BuyerLoginPage';
import './App.css';

function PublicLayout({ children }) {
  return (
    <>
      <PublicHeader />
      <PageTracker />
      {children}
      <PublicFooter />
      <QuoteDrawer />
    </>
  );
}

function AppRoutes() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  const isBuyerLogin = location.pathname === '/buyer/login';

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    );
  }
  if (isBuyerLogin) {
    return <Routes><Route path="/buyer/login" element={<BuyerLoginPage />} /></Routes>;
  }

  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/catalog" element={<CatalogPage />} />
        <Route path="/product/:id" element={<ProductDetailPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/private-label" element={<PrivateLabelPage />} />
      </Routes>
    </PublicLayout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <BuyerAuthProvider>
            <QuoteCartProvider>
              <AppRoutes />
              <Toaster position="top-right" richColors />
            </QuoteCartProvider>
          </BuyerAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
